var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-card',{attrs:{"title":"프립 약관 관리","notification":"(구)어드민의 '회사 정보 및 약관'페이지가 열립니다."}})}
var staticRenderFns = []

export { render, staticRenderFns }